"use strict";
import { CreditCardIcon } from "components/Icons/CreditCard";
import { Limit } from "components/Icons/Limit";
import { Send } from "components/Icons/Send";
import { SwapV2 } from "components/Icons/SwapV2";
import { useTheme } from "lib/styled-components";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { FeatureFlags } from "uniswap/src/features/gating/flags";
import { useFeatureFlag } from "uniswap/src/features/gating/hooks";
export const useTabsContent = () => {
  const { t } = useTranslation();
  const isLPRedesignEnabled = useFeatureFlag(FeatureFlags.LPRedesign);
  const { pathname } = useLocation();
  const theme = useTheme();
  const showExploreTab = false;
  const showLimitTradeItem = false;
  const showSendTradeItem = false;
  const showBuyTradeItem = false;
  const tradeSection = {
    title: t("common.trade"),
    href: "/swap",
    isActive: pathname.startsWith("/swap") || pathname.startsWith("/limit") || pathname.startsWith("/send"),
    items: [
      {
        label: t("common.swap"),
        icon: <SwapV2 fill={theme.neutral2} />,
        quickKey: "U",
        href: "/swap",
        internal: true
      },
      ...showLimitTradeItem ? [
        {
          label: t("swap.limit"),
          icon: <Limit fill={theme.neutral2} />,
          quickKey: "L",
          href: "/limit",
          internal: true
        }
      ] : [],
      ...showSendTradeItem ? [
        {
          label: t("common.send.button"),
          icon: <Send fill={theme.neutral2} />,
          quickKey: "E",
          href: "/send",
          internal: true
        }
      ] : [],
      ...showBuyTradeItem ? [
        {
          label: t("common.buy.label"),
          icon: <CreditCardIcon fill={theme.neutral2} />,
          quickKey: "B",
          href: "/buy",
          internal: true
        }
      ] : []
    ]
  };
  const exploreSection = {
    title: t("common.explore"),
    href: "/explore",
    isActive: pathname.startsWith("/explore") || pathname.startsWith("/nfts"),
    items: [
      { label: t("common.tokens"), quickKey: "T", href: "/explore/tokens", internal: true },
      { label: t("common.pools"), quickKey: "P", href: "/explore/pools", internal: true },
      {
        label: t("common.transactions"),
        quickKey: "X",
        href: "/explore/transactions",
        internal: true
      }
    ]
  };
  const poolSection = {
    title: t("common.pool"),
    href: isLPRedesignEnabled ? "/positions" : "/pool",
    isActive: pathname.startsWith("/pool"),
    items: [
      {
        label: t("nav.tabs.viewPositions"),
        quickKey: "V",
        href: isLPRedesignEnabled ? "/positions" : "/pool",
        internal: true
      },
      {
        label: t("nav.tabs.createPosition"),
        quickKey: "V",
        href: isLPRedesignEnabled ? "/positions/create" : "/add",
        internal: true
      }
    ]
  };
  return [tradeSection, ...showExploreTab ? [exploreSection] : [], poolSection];
};
